module.exports = __webpack_public_path__ + "static/Unity_Tower_upper_floor_modern_v2-d5e86f722b28c0b474bb70c1b1c72445.png";